export default {"src":"/_next/static/media/deposit.e76907ec.svg","height":14,"width":50,"blurWidth":0,"blurHeight":0};